/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';

/**
 * Service to fetch system-to-system tokens for aiadmin module
 */
export default class GetSys2sysTokenService extends BaseService {
  constructor() {
    super(constants.GET_SYS2SYS_TOKEN, 'aiadminGetSys2sysTokenStatus');
  }

  handleEvent(eventName, event) {
    const { payload } = event;
    const { forProd } = payload || {};

    const headers = {
      'Content-Type': 'application/json'
    };

    const queryParam = forProd ? `?prod=${forProd}` : '';
    return this.getClient('aiadmin').get(`/${constants.GET_SYSTEM_TOKEN_URL}${queryParam}`, { headers });
  }

  handleResponse(response, event) {
    const requestId = event?.payload?.requestId;
    const { data } = response;
    if (data && data.data) {
      Framework.getEventManager().publish(constants.GET_SYS2SYS_TOKEN_SUCCESS, {
        data,
        requestId
      });
    } else {
      Framework.getEventManager().publish(constants.GET_SYS2SYS_TOKEN_ERROR, {
        message: data?.message || 'Error fetching system token',
        requestId
      });
    }
  }

  handleError(error, event) {
    const requestId = event?.payload?.requestId;
    Framework.getEventManager().publish(constants.GET_SYS2SYS_TOKEN_ERROR, {
      message: error?.message || 'Error fetching system token',
      requestId
    });
  }
}
